import React, { memo } from 'react';
import { View, ScrollView } from 'react-native';
import { Card, Text } from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { PreviewDashboardPage } from '@redlink/components/pages';

export const PreviewSimulatePage = memo(() => {
  const { styles } = useStyle();
  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View>
        <Text>Preview</Text>
        <Card style={styles.card}>
          <PreviewDashboardPage />
        </Card>
      </View>
    </ScrollView>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    paddingHorizontal: size.screenHorizontalPadding,
    paddingVertical: size.screenVerticalPadding,
  },
  card: {
    width: 360,
    height: 640,
    marginTop: 8,
    padding: 0,
  },
}));
